"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENTERPRISE_AGENT_FLOW = exports.COMMON = exports.BORROWER_FLOW = exports.A11Y_IMAGE_DESCRIPTIONS = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// TODO: replace these with Enum on port to Typescript
var A11Y_IMAGE_DESCRIPTIONS = {
  EARNUP_HELPS_IMAGE: 'Illustration of person sitting on chair with laptop',
  EARN_UPPERS_GROUP_IMAGE: 'Illustration of a group in celebration',
  ONE_EMAIL_IMAGE: 'Illustration of an email with a notification bubble',
  PAD_LOCK_IMAGE: 'Illustration of a padlock'
};
exports.A11Y_IMAGE_DESCRIPTIONS = A11Y_IMAGE_DESCRIPTIONS;
var COMMON = {
  ALREADY_HAVE_ACCOUNT: 'Have an Account?',
  CAVEAT: 'By clicking Continue you agree to ',
  SUPPORT_CAVEAT: 'By clicking Send you agree to ',
  E_SIGN_CONSENT: 'E-sign consent',
  LOGIN: 'Login',
  NEED_HELP: 'Need Help?',
  PASSWORD_REQUIREMENTS: '10+ characters, at least 1 uppercase and a number',
  PRIVACY_POLICY: 'EarnUp Privacy Policy',
  PRIVACY_POLICY_SHORT: 'Privacy Policy',
  SUPPORT: 'Support',
  TRUST_PAGE: 'Trust Page',
  TERMS_AND_CONDITIONS: 'EarnUp Terms and Conditions',
  TERMS_AND_CONDITIONS_SHORT: 'Terms'
};
exports.COMMON = COMMON;
var ENTERPRISE_AGENT_FLOW = (0, _extends2["default"])({}, COMMON, {
  IMAGE_CAPTION: "EarnUp's award-winning financial technology provides enterprise clients with just-in-time data that identifies borrowers who will benefit from interventions or new services.",
  SIGN_UP_HEADER: 'Sign up to GetAhead Dashboard',
  SIGN_UP_BUTTON: 'SIGN UP',
  FORM: {
    EMAIL_REQUIRED: 'Must provide a valid work email',
    EMAIL_MUST_BE_VALID: 'Work email must be a valid email address',
    FIRST_NAME_REQUIRED: 'First name must be at least 2 characters',
    LAST_NAME_REQUIRED: 'Last name must be at least 2 characters',
    COMPANY_NAME_REQUIRED: 'Company name is required',
    PASSWORD_REQUIRED: 'Password must contain 10+ characters, at least 1 uppercase and a number',
    ERROR: 'Something went wrong. Please verify the information above and try again.',
    LAST_NAME: 'Last Name',
    FIRST_NAME: 'First Name',
    WORK_EMAIL: 'Work Email',
    PASSWORD: 'Password',
    COMPANY_NAME: 'Company Name'
  },
  SUPPORT_MODAL: {
    HEADER: 'Support',
    CLOSE_BUTTON: 'Cancel',
    SUBMIT_BUTTON: 'Send'
  },
  SUCCESS_HEADER: 'Thank you for signing up',
  SUCCESS_MESSAGE: "You'll receive an email to verify your email shortly. Please click 'Verify Email' from the email to access to GetAhead Dashboard. If you have not received the email, please click resend. ",
  RESEND_EMAIL: 'Re-Send Email'
});
exports.ENTERPRISE_AGENT_FLOW = ENTERPRISE_AGENT_FLOW;
var BORROWER_FLOW = (0, _extends2["default"])({}, COMMON, {
  MAKE_PAYMENTS_ON_TIME: 'Make flexible, on-time payments with EarnUp!',
  WE_TAKE_PRIVACY_SERIOUSLY: 'We take protecting your data seriously and use end-to-end 256-bit encryption.',
  LEARN_MORE: ' Learn more on our ',
  BETTER_BUDGETING_HEADER: 'Better Budgeting',
  BETTER_BUDGETING_PITCH: 'Every time you get paid, reserve a portion to put towards your mortgage. EarnUp will take care of the rest and send your payment, on-time to your lender or servicer.',
  FASTER_PAYDOWN_HEADER: 'Faster Pay Down',
  FASTER_PAYDOWN_PITCH: 'Accelerate! Set up a plan that will allow for you to pay more toward your principal.',
  SIGN_UP_HEADER: "Let's Get Started!",
  SIGN_UP_SUB_HEADER: function SIGN_UP_SUB_HEADER() {
    var privateLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'valued';
    return "As a ".concat(privateLabel, " customer, you can take control of your mortgage payments through EarnUp's easy-to-manage platform.");
  },
  SIGN_UP_INSTRUCTIONS: 'We can make your account set up easy! Just allow us to connect to your mortgage account by providing the information below.',
  SIGN_UP_BUTTON: 'Continue',
  WHY_NEED_THIS_INFO: 'Why does EarnUp need this information?',
  PRIVACY_POLICY: 'Privacy Policy',
  WHY_NEED_INFO_EXPLANATION: 'We require this information in order to match you with your mortgage account information.',
  CONSENT: "By clicking continue you authorize EarnUp to obtain and use your information from your lender to provide our services subject to EarnUp's",
  FORM: {
    VALID_SSN_REQUIRED: 'Must be valid serial number',
    BIRTH_YEAR_REQUIRED: 'Must be valid year',
    LAST_FOUR_SSN: 'Last 4 digits of your SSN',
    BIRTH_YEAR: 'Birth Year',
    ERROR: function ERROR(phone_num) {
      return "Hmm, looks like that didn't match what we have on file. Please try re-entering the last 4 digits of your social security number and birth year below. If it still doesn't work, please give us a call at ".concat(phone_num, " so we can help you out.");
    }
  }
});
exports.BORROWER_FLOW = BORROWER_FLOW;